(() => {
  const STORAGE_KEY = 'isarttools_geo_market_v1';
  const SUPPORTED_COUNTRIES = new Set(['SA', 'EG']);

  if (!window.Shopify || !window.Shopify.routes || typeof fetch !== 'function') return;

  const currentCountry = String(window.Shopify.country || '').toUpperCase();
  if (!currentCountry) return;

  let lastAutomaticCountry = '';
  try {
    lastAutomaticCountry = sessionStorage.getItem(STORAGE_KEY) || '';
  } catch (error) {}

  const params = new URLSearchParams();
  params.set('country[enabled]', 'true');
  params.set('country[exclude]', currentCountry);
  params.set('language[enabled]', 'false');

  fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json?${params.toString()}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      if (!data || !Array.isArray(data.suggestions)) return;

      const targetCountry = data.suggestions
        .map((suggestion) => suggestion?.parts?.country?.handle)
        .filter(Boolean)
        .map((code) => String(code).toUpperCase())
        .find((code) => SUPPORTED_COUNTRIES.has(code));

      if (!targetCountry || targetCountry === currentCountry) {
        try {
          if (targetCountry === currentCountry) sessionStorage.setItem(STORAGE_KEY, targetCountry);
        } catch (error) {}
        return;
      }

      // Respect a customer's manual country choice for the rest of this browsing session.
      if (lastAutomaticCountry === targetCountry) return;

      try {
        sessionStorage.setItem(STORAGE_KEY, targetCountry);
      } catch (error) {}

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/localization';
      form.hidden = true;

      const fields = {
        _method: 'PUT',
        country_code: targetCountry,
        language_code: window.Shopify.language || document.documentElement.lang || 'en',
        return_to: `${window.location.pathname}${window.location.search}`,
      };

      Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    })
    .catch(() => {});
})();